import type {Editor} from "slate";

/**
 * This is a Slate plugin that adds support for math-inline and math-block
 * elements.
 */
export const withMath = (editor: Editor): Editor => {
    const {isInline, isBlock, isSelectable, isVoid} = editor;

    editor.isVoid = (element) =>
        element.type === "math-inline" ||
        element.type === "math-block" ||
        isVoid(element);

    editor.isInline = (element) =>
        element.type === "math-inline" || isInline(element);

    editor.isBlock = (element) =>
        element.type === "math-block" || isBlock(element);

    editor.isSelectable = (element) =>
        element.type === "math-inline" ||
        element.type === "math-block" ||
        isSelectable(element);

    return editor;
};
